import React, { useCallback, useEffect, useState } from "react";
import {
  LanguageSwitcherSelectors,
  UserContextSelectors
} from "../../redux/selectors";
import { LanguagesMenuMobile, LanguagesMenuPC } from "./loader";
import { useDispatch, useSelector } from "react-redux";
import { UrlUtils, TrackingUtils } from "../../utils";
import classNames from "classnames";
import { getLanguageSwitcherData } from "./Logic/LanguageSwitcherLogic";
import { BrandUtils } from "../../utils/brandUtils";
import { NavigationUtils } from "../../utils";
import { SVGIcon2 } from "../common/SVGIconV2";
import { PageContextUtils } from "../../utils";

const LanguagesMenu = () => {
  const dispatch = useDispatch();
  const data = useSelector(LanguageSwitcherSelectors.data);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const isNative = useSelector(UserContextSelectors.isNative);
  const publicationId = useSelector(LanguageSwitcherSelectors.publicationId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const [active, setActive] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [countries, setCountries] = useState([]);
  const { mainPage } = PageContextUtils.getSiteData();

  useEffect(() => {
    getLanguageSwitcherData(
      window.location.href,
      publicationId,
      mainPage,
      dispatch
    );
  }, [dispatch, isAuthenticated, mainPage, publicationId]);

  const handleLanguageOrCountryClick = (selected, isLanguage) => {
    TrackingUtils.sendAnalytics({
      dataCategory: "User Area",
      dataAction: "click",
      dataLabel: isLanguage ? "Selected language" : "Selected country",
      dataCustom: { language: selected }
    });
  };

  useEffect(() => {
    const createLanguage = (title, url) => {
      var language = {
        title: title,
        url: url
      };

      return language;
    };

    const getNavigationUrl = url => {
      return UrlUtils.getURLWithOrigin(url, window.location.origin);
    };

    let currentLang = "English";
    if (data?.languageSettings?.current) {
      currentLang = data.languageSettings.current;
      const hasLanguage = data.languages.some(x => x.title === currentLang);
      if (!hasLanguage) data.languages.push(createLanguage(currentLang, ""));
    }

    setLanguages(
      data?.languages?.map((item, index) => {
        const url = !BrandUtils.isPokerClient()
          ? getNavigationUrl(item.url)
          : item.url;
        return (
          <li key={index}>
            <a
              href={url}
              className={classNames({
                checkedOption: item.title === currentLang
              })}
              data-navigation-ignore
              onClick={() => handleLanguageOrCountryClick(item.title, true)}
            >
              {isMobile && (
                <i>
                  <SVGIcon2 iconName="check" />
                </i>
              )}
              <span className="ellipsis-span">{item.title}</span>
            </a>
          </li>
        );
      })
    );
  }, [data?.languageSettings, data?.languages, isMobile]);

  useEffect(() => {
    setCountries(
      data?.countries?.map((item, index) => (
        <li key={index}>
          <a
            href={
              isNative
                ? NavigationUtils.addQueryToLink(item.url, {
                    NativeExternal: "true"
                  })
                : item.url
            }
            target={(isNative && "_blank") || "_self"}
            data-navigation-ignore
            onClick={() => handleLanguageOrCountryClick(item.title, false)}
          >
            {isMobile && (
              <i>
                <svg>
                  <use />
                </svg>
              </i>
            )}

            <span className="ellipsis-span">{item.title}</span>
          </a>
        </li>
      ))
    );
  }, [data?.countries, isMobile, isNative]);

  const toggleClass = useCallback(
    isActive => {
      if (typeof isActive === "boolean") setActive(isActive);
      else setActive(!active);
    },
    [active]
  );

  if (!data || !Object.keys(data).length) return null;

  return isMobile ? (
    <LanguagesMenuMobile languages={languages} countries={countries} />
  ) : (
    <LanguagesMenuPC
      languages={languages}
      countries={countries}
      toggleClass={toggleClass}
      active={active}
    />
  );
};
export default LanguagesMenu;
